module.exports = __webpack_public_path__ + "img/9-4-2022_raices.bb70fe7f.jpeg";